import {
  Component,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'launch-page-component',
  templateUrl: './launchpage.component.html',
  styleUrls: [],
})
export class LaunchpageComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private platformLocation: PlatformLocation
  ) {}

  ngOnInit() {
    console.log('进入launch-page');
    let targetUrl = this.platformLocation['location']['href'].split('?')[1] ? this.platformLocation['location']['href'].split('?')[1] : '';
    let param = '';
    if (typeof window.localStorage !== 'undefined' &&
      window.localStorage.getItem('transtalen-token') &&
      window.localStorage.getItem('transtalenuserid')) {
      if(targetUrl){
        param = '&' + targetUrl;
      }
      this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?token=' + window.localStorage.getItem('transtalen-token') + param;
    } else {
      if(targetUrl){
        targetUrl = '?' + targetUrl;
      }
      this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/new-login' + targetUrl;
    }
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/launchpage.component.ts